<template>
  <panel title="产品库存情况" class="mgb10">
    <vxe-table
      :data="records"
      border
      size="small"
      :loading="loading"
      class="border-inner-top"
      auto-resize
      highlight-hover-row
      :scroll-y="{ enabled: false }"
    >
      <vxe-table-column field="shopName" title="仓库"></vxe-table-column>
      <vxe-table-column
        field="productNoQty"
        :title="$t('report.productQty')"
      ></vxe-table-column>
      <vxe-table-column field="quantity" title="库存量"></vxe-table-column>
      <vxe-table-column field="totalLock" title="锁定量"></vxe-table-column>
      <template v-slot:empty>
        <p>暂无数据</p>
      </template>
    </vxe-table>
  </panel>
</template>

<script>
import Inventory from "@/api/inventory.js";
export default {
  data() {
    return {
      loading: false,
      records: [],
    };
  },
  created() {
    const self = this;
    self.loading = true;
    Inventory.invInfoCount().then(function (res) {
      if (res.status == 200) {
        self.records = res.data;
      } else {
        self.sysError();
      }
      self.loading = false;
    });
  },
};
</script>